// extracted by mini-css-extract-plugin
module.exports = {"EditorWork":"_1h_rDTsp","titleBlock":"_2Su6nrTq","workHistoryBlock":"_1KmwAlYO","title":"bkRRMcT5","scrollDiv":"_1A2_RyIh","titleContainer":"_2ffIdI8b","autoSaving":"VYsMV-z8","autoSaved":"_1H6N85G9","saveContent":"_2xn5wlMN"};
    if(module.hot) {
      // 1746735834216
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  